import { render, staticRenderFns } from "./message.vue?vue&type=template&id=4260866a&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=4260866a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260866a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4260866a')) {
      api.createRecord('4260866a', component.options)
    } else {
      api.reload('4260866a', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=4260866a&scoped=true", function () {
      api.rerender('4260866a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recruitment/message.vue"
export default component.exports